export default __webpack_public_path__ + "static/media/acc-manager.288543a1.svg";